<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo de Apólice</span>
          <v-select
            :options="listApolices"
            :reduce="(item) => item.id"
            name="Tipo de Apólice"
            id="Tipo de Apólice"
            v-model="formCadastro.tipo_apolice_id"
            v-validate="{ required: true }"
            :state="validateState('Tipo de Apólice')"
            :class="validateStateClass('Tipo de Apólice')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Modelo de Foto</span>
          <v-select
            :options="tiposModelosFotos"
            name="Modelo de Foto"
            id="Modelo de Foto"
            v-model="formCadastro.idModeloFoto"
            label="label"
            v-validate="{ required: true }"
            :state="validateState('Modelo de Foto')"
            :class="validateStateClass('Modelo de Foto')"
          ></v-select>
          <vs-button
            class="mt-2 w-full"
            color="success"
            @click.stop.prevent="abrirModalNovoModeloFoto"
            >Novo Modelo de Foto</vs-button
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo de Foto</span>
          <v-select
            :options="tiposFotos"
            name="Tipo de Foto"
            id="Tipo de Foto"
            v-model="formCadastro.tipoFoto"
            v-validate="{ required: true }"
            :state="validateState('Tipo de Foto')"
            :class="validateStateClass('Tipo de Foto')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Ordenação</span>
          <vs-input
            type="number"
            size="large"
            class="w-full"
            name="Ordenação"
            id="Ordenação"
            v-model="formCadastro.posicao"
            v-validate="{ required: true }"
            :state="validateState('Ordenação')"
            :class="validateStateClass('Ordenação')"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Legenda</span>
          <vs-input
            type="text"
            size="large"
            class="w-full"
            name="Legenda"
            id="Legenda"
            v-model="formCadastro.legenda"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Obrigatório</span>
          <vs-switch
            color="success"
            v-model="formCadastro.obrigatorio"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Exclusivo Implemento</span>
          <vs-switch
            color="success"
            v-model="formCadastro.implemento"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Exclusivo Agregado</span>
          <vs-switch
            color="success"
            v-model="formCadastro.agregado"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6 w-full">
          <span>Exclusivo para Produto</span>
          <v-select
            :options="produtos"
            name="Exclusivo para Produto"
            id="Exclusivo para Produto"
            v-model="formCadastro.idProduto"
            :reduce="(item) => item.id"
            label="label"
            :state="validateState('Exclusivo para Produto')"
            :class="validateStateClass('Exclusivo para Produto')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col mb-6 w-full">
          <span>Exclusivo para Tipo de Proposta</span>
          <v-select
            :options="tiposProposta"
            :reduce="(item) => item.label"
            name="Exclusivo para Tipo de Proposta"
            id="Exclusivo para Tipo de Proposta"
            v-model="formCadastro.tipoProposta"
            :state="validateState('Exclusivo para Tipo de Proposta')"
            :class="validateStateClass('Exclusivo para Tipo de Proposta')"
          ></v-select>
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idModeloFotoEmpresa == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>

    <ModalNovoModeloFoto
      :active="mostrarModalNovoModeloFoto"
      @close="fecharModalNovoModeloFoto"
    />
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import utilsList from '../../utils/list';
import ErrorsAlert from '../../components/ErrorsAlert';
import ModalNovoModeloFoto from '../modais/ModalNovoModeloFoto.vue';

export default {
  name: 'FormTipoFoto',
  components: {
    ErrorsAlert,
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
    ModalNovoModeloFoto,
  },
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  data() {
    return {
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      tiposModelosFotos: [],
      listApolices: [],
      produtos: [],
      tiposProposta: [],
      tiposFotos: ['Vistoria', 'Documentação'],
      tipos: [],
      formCadastro: {
        status: true,
        idModeloFotoEmpresa: null,
        idEmpresa: null,
        idModeloFoto: null,
        tipo_apolice_id: null,
        obrigatorio: false,
        posicao: null,
        tipoFoto: null,
        legenda: null,
        agregado: null,
        implemento: null,
        idProduto: null,
        tipoProposta: null,
        idTipo: null,
      },
      mostrarModalNovoModeloFoto: false,
    };
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  methods: {
    preencheForm() {
      if (this.dados.idModeloFotoEmpresa) {
        this.formCadastro.idModeloFotoEmpresa = this.dados.idModeloFotoEmpresa;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.idModeloFoto = {
          id: this.dados.idModeloFoto,
          label: this.dados.Posicao,
        };
        this.formCadastro.obrigatorio = this.dados.obrigatorio;
        this.formCadastro.posicao = this.dados.ordem;
        this.formCadastro.tipoFoto = this.dados.tipoFoto;
        this.formCadastro.legenda = this.dados.legenda;
        this.formCadastro.agregado = this.dados.agregado;
        this.formCadastro.implemento = this.dados.implemento;
        this.formCadastro.idProduto = this.dados.idProduto;
        this.formCadastro.tipoProposta = this.dados.tipoProposta;
        this.formCadastro.tipo_apolice_id = this.dados.tipo_apolice_id;
        this.formCadastro.idTipo = this.dados.idTipo;
      } else {
        this.resetForm();
      }
    },
    async onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      let action = 'Atualizar';
      let msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idModeloFotoEmpresa) {
        action = 'Adicionar';
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      const valid = await this.$validator.validateAll();

      if (valid) {
        try {
          this.aguardeCadastro = true;
          await service.post('TipoFoto', action, this.formCadastro);
          this.aguardeCadastro = false;
          notify.notifySuccess(this.$vs, msgRetorno);
          this.$emit('concluido');
        } catch (error) {
          this.aguardeCadastro = false;
          notify.notifyFail(this.$vs, error);
        }
      }
    },
    abrirModalNovoModeloFoto() {
      this.mostrarModalNovoModeloFoto = true;
    },
    async fecharModalNovoModeloFoto(nomeNovaFoto) {
      this.tiposModelosFotos = await functions.buscaDadosSelects(
        'domModelosFotos',
        [],
        'nomePosicao',
        'idModeloFoto',
      );
      const novaFoto = this.tiposModelosFotos.find(
        (tipo) => tipo.label === nomeNovaFoto,
      );
      this.formCadastro.idModeloFoto = novaFoto;
      this.mostrarModalNovoModeloFoto = false;
    },
    buscaDadosProdutos() {
      service
        .getAll('g', {}, `produtos/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            this.produtos.push({
              id: element.idProduto,
              label: element.nomeProduto,
            });
          });
        });
    },
    resetForm() {
      this.formCadastro = {
        status: true,
        idModeloFotoEmpresa: null,
        idEmpresa: null,
        idModeloFoto: null,
        obrigatorio: false,
        posicao: null,
        tipoFoto: null,
        implemento: null,
        agregado: null,
        idProduto: null,
        tipoProposta: null,
        tipo_apolice_id: null,
        idTipo: null,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    async getDominios() {
      try {
        const promises = [];
        if (!this.listApolices.length) {
          promises.push(
            functions.buscaDadosSelects(
              'tipoApolices',
              [],
              'nome',
              'tipoApoliceId',
            ),
          );
        }
        if (!this.tiposModelosFotos.length) {
          promises.push(
            functions.buscaDadosSelects(
              'domModelosFotos',
              [],
              'nomePosicao',
              'idModeloFoto',
            ),
          );
        }
        if (!this.tiposProposta.length) {
          promises.push(
            functions.buscaDadosSelects(
              'domTipoProposta',
              [],
              'label',
              'idTipoProposta',
            ),
          );
        }

        const [listApolices, listTiposModelosFotos, listTiposProposta] =
          await Promise.all(promises);

        this.listApolices = listApolices;
        this.tiposModelosFotos = listTiposModelosFotos;
        this.tiposProposta = listTiposProposta;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
  },
  mounted() {
    this.getDominios();
    this.buscaDadosProdutos();
  },
};
</script>
<!------------ END SCRIPT ------------>
